export default "<app-reset-pass-form></app-reset-pass-form>\n"